import { CropBox } from "@/store/types/crop";
import { BulkResizeImage } from "../../types";

export const getCropOperation = (image: BulkResizeImage, cropBox: CropBox | null) =>
    ({
        name: "crop",
        value: {
            cropBox,
            rotation: image.rotate.rotation,
        },
    }) as const;
